import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

interface BpsLegendItem {
  borderColor: string,
  fillColor: string,
  regionCode: string,
}

interface Props {
  items: BpsLegendItem[],
  selectedRegion: string | undefined,
  onRegionSelected: React.Dispatch<React.SetStateAction<string | undefined>>,
}

const Wrapper = styled.div`
  color: #ffffff;
  font-family: DMSans-Bold;
  font-size: 0.91rem;

  .legend-item {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    margin-bottom: 1em;
  }
`;

interface LegendBoxProps {
  backgroundColor: string,
  borderColor: string,
}

const LegendBox = styled.div<LegendBoxProps>`
  background-color: ${ props => props.backgroundColor };
  border: 1.3px solid ${ props => props.borderColor };
  display: inline-block;
  margin-right: 1em;
  height: 1em;
  width: 1em;
`;

const BpsLegend = ({ items, onRegionSelected, selectedRegion }: Props) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      { items.map(item => (
          <div
            key={ `legend-item-${item.regionCode}` }
            className='legend-item'
            onClick={ () => {
              if (selectedRegion) {
                onRegionSelected(undefined);
              } else {
                onRegionSelected(item.regionCode);
              }
            } }
          >
            <LegendBox
              backgroundColor={ item.fillColor }
              borderColor={ item.borderColor }
            />
            <div className='leged-item__region-name'>
              { t(`regions.${ item.regionCode }`) }
            </div>
          </div>
        ))
      }
    </Wrapper>
  )
};

export default BpsLegend;
